export default function Contact() {
    return (
        <div className="max-w-5xl mx-auto mt-8 px-4 space-y-8">
            <h1 className="text-4xl font-bold">Contact</h1>
            <p>Please reach out to <a href="mailto:giftloopapph@gmail.com" className="text-blue-600 underline">giftloopapp@gmail.com</a>.</p>
        </div>
    );
}
